<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">
            <div class="col-md-12 rolelist" v-if="Auth.role == 1">
                <div class="addrole">
                    <!-- <router-link to="/admin/dashboard/addrole"><a class="">Add Role</a></router-link> -->
                </div>
            </div>

            <div class="col-md-12 rolelistupper">
                <div class="card">
                    <h5 class="card-title">Orders List</h5>
                    <FlashMessage :position="'right top'"></FlashMessage>

                    <div class="card-body table-responsive table-full-width">

                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Purchase Date</th>
                                    <th>Name</th>
                                    <th>Grand Total</th>
                                    <th>status</th>
                                    <th>Purchase From</th>
                                    <th>Invoice</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in tableData" v-bind:key="data.orderreferenceid">
                                    <td>{{data.orderreferenceid}}</td>
                                    <td>{{data.created_at | formatDate}}</td>
                                    <td>{{data.name}}</td>
                                    <td>₹{{data.totalprice}}</td>
                                    <td>{{data.orderstatusname}}</td>
                                    <td>{{data.purchasefrom}}</td>
                                    <td>
                                        <a @click="generateReport(data.orderreferenceid)">
                                            <b-icon-printer></b-icon-printer>
                                        </a>
                                    </td>
                                    <td>
                                        <router-link :to="'/admin/dashboard/orderdetail/' + data.orderreferenceid"><button class="btnborderremove">
                                                <a>
                                                    <b-icon-eye></b-icon-eye>
                                                </a>
                                            </button></router-link>
                                    </td>

                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

    
<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import datatable from "datatables.net-bs4"
import download from 'downloadjs'
import Auth from '../../../Auth.js';
import Vue from 'vue'
import $ from "jquery"
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'listOrders',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            tableData: [],
            Auth: '',
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/orders`).then((res) => {
                this.tableData = res.data;
                this.table();

            });
        },

        generateReport(id) {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/generatepdf/` + id, {
                responseType: 'blob'
            }).then((res) => {
                const content = res.headers['content-type'];
                download(res.data, 'invoice', content)
            });
        },

    },

    mounted() {
        this.getData();
        this.Auth = Auth.user;
    },

};
</script>

    
<style lang="scss">

    </style>
